import { parseEntityItemId } from '@wix/a11y-rules';
import _ from 'lodash';
import { modify } from 'ricos-content/libs/modify';
import { buildSingleNode } from '../../utils/build-single-rich-content-node';
export const buildPostsBulkUpdatePayload = (altTextData, blogMap) => {
  const payload = [];
  const updatesByPostId = _.groupBy(altTextData.map(_ref => {
    let {
      id,
      alt
    } = _ref;
    const {
      itemId: imageId,
      entities
    } = parseEntityItemId(id, 2);
    const [postId, nodeId] = entities;
    const blogPost = blogMap.get(postId ?? '');
    return {
      alt,
      entityId: (blogPost == null ? void 0 : blogPost.id) ?? '',
      imageId,
      nodeId,
      postId
    };
  }), upd => upd.entityId);
  Object.entries(updatesByPostId).forEach(_ref2 => {
    let [postId, updatesForPost] = _ref2;
    if (!postId) {
      return;
    }
    const originalPost = blogMap.get(postId);
    if (!originalPost) {
      return;
    }
    const richContent = originalPost == null ? void 0 : originalPost.richContent;
    const updatesByNodeId = _.groupBy(updatesForPost, upd => upd.nodeId);
    const updatedRichContent = modify(richContent).filter(node => Object.keys(updatesByNodeId).includes(node.id)).set(node => buildSingleNode(node, updatesByNodeId[node.id]));
    const updatedPost = {
      id: postId,
      richContent: updatedRichContent
    };
    payload == null || payload.push({
      draftPost: updatedPost,
      fieldMask: ['richContent']
    });
  });
  return payload;
};
//# sourceMappingURL=bulk-update-blog-posts-alt-text-payload-builder.js.map